function getAddress(location = {}) {
  const {
    address_line1,
    address_line2,
    city,
    state_province,
    postal_code,
  } = location;
  let address = [address_line1, address_line2, city, state_province]
    .filter(item => item)
    .join(', ');
  if (postal_code) {
    address += ` ${postal_code}`;
  }
  return address;
}

export default getAddress;
